import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BillPreviewPage } from '../bill-preview/bill-preview';
import { BusinessProvider } from '../../providers/business/business';

@IonicPage()
@Component({
  selector: 'page-billing',
  templateUrl: 'billing.html',
})
export class BillingPage {
  // data from the previous pages
  previewData: any;
  // customer form data
  customerData: any;
  vechileStatus: any;
  commercials: any;
  nextVisit: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $business: BusinessProvider) {
    this.previewData = this.navParams.get('previewData');
    this.customerData = this.previewData.customerData;
  }

  ionViewDidLoad() {
    this.initVechileStaus();
    this.initBilling();
    this.initNextVisit();
  }

  initVechileStaus(): void {
    this.vechileStatus = {
      engineNoiseBefore: 'NA',
      engineNoiseAfter: 'NA',
      engineEmissionBefore: 'NA',
      engineEmissionAfter: 'NA',
      vibrationBefore: 'NA',
      vibrationAfter: 'NA',
      powerReducedBefore: 'NA',
      powerReducedAfter: 'NA',
      driveComfortReducedBefore: 'NA',
      driveComfortReducedAfter: 'NA',
      gearBefore: '0',
      gearAfter: '0',
      rpmBefore: '0',
      rpmAfter: '0',
      speedBefore: '0',
      speedAfter: '0'
    }
  }

  initBilling(): void {
    this.commercials = {
      hhoPrice: 0,
      specialDiscount: 0,
      total: 0,
      estimateInWords: '',
      sGst: 0,
      iGst: 0,
      otherTax: 0,
      otherTaxName: '',
    }
  }

  initNextVisit(): void {
    this.nextVisit = {
      odo: 0,
      estimatedCost: 0,
      estimatedDate: '',
    }
  }


  // form the component
  vechileStatusChange(newStatus) {
    // filter out non required event emmisions
    if (newStatus.engineEmissionAfter) {
      this.vechileStatus = newStatus;
    }
  }

  // from the component 
  commercialsChange(newCommercial) {
    if (newCommercial.total) {
      this.commercials = newCommercial;
    }
  }

  //from the component
  nextVisitChange(newNextVisit) {
    if (newNextVisit.odo) {
      this.nextVisit = newNextVisit;
    }
  }

  saveAndContinue() {
    let obj = {
      ... this.previewData,
      nextVisit: this.nextVisit,
      commercials: this.commercials,
      vechileStatus: this.vechileStatus,
    };
    this.$business.insertBilling(obj).then(response => {
      // keep the console log intact
      console.log( response.id);
      this.navCtrl.push(BillPreviewPage, { billKey: response.id });
    })

  }
}



// WEBPACK FOOTER //
// ./src/pages/billing/billing.ts